import { Box, Button, Text } from '@trmediaab/zebra';
import type { PaywallReason } from '@trmediaab/zebra-types/trais';
import type { MaxWidthProps, MinWidthProps, WidthProps } from 'styled-system';

import AltContentDivider from '../AltContentDivider';

interface ReasonInfoProps {
  authUrl: string;
  reason: PaywallReason;
  insufficientPrivilegeMessage: string;
  loggedOutMessage: string;
  hasOffer: boolean;
  ctaButtonWidths: {
    width: WidthProps['width'];
    maxWidth: MaxWidthProps['maxWidth'];
    minWidth: MinWidthProps['minWidth'];
  };
}

const ReasonInfo = ({
  authUrl,
  reason,
  insufficientPrivilegeMessage,
  loggedOutMessage,
  hasOffer,
  ctaButtonWidths,
}: ReasonInfoProps) => {
  // User is logged in but no active subscription
  const insufficientPrivilege = reason === 'unauthorized';

  return insufficientPrivilege ? (
    <Text.p pb="2">
      <Text.strong>Du behöver uppgradera ditt konto</Text.strong>
      <br />
      {insufficientPrivilegeMessage}
    </Text.p>
  ) : (
    <>
      <Text.p>{loggedOutMessage}</Text.p>

      <Button
        bc="offersSecondary"
        href={authUrl}
        {...ctaButtonWidths}
        pb={hasOffer ? undefined : 4}
      >
        Logga in
      </Button>

      {hasOffer && (
        <Box px={{ _: 3, sm: 4 }}>
          <AltContentDivider text="Eller" />
        </Box>
      )}
    </>
  );
};

export default ReasonInfo;
